import { useLocation, useNavigate } from "react-router-dom";
import { webPaths } from "../routes/pageRoutes";

const AuthLayout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isModalView = Boolean(location?.state?.backgroundLocation);

  const handleClose = () => {
    if (location?.state?.backgroundLocation) {
      navigate(location.state.backgroundLocation, { replace: true });
      return;
    }

    navigate(webPaths?.WebHome);
  };

  return (
    <div class={isModalView ? "ct_auth_modal_overlay" : "ct_login_main_bg"}>
      <div class={isModalView ? "container ct_auth_modal_container" : "container"}>
        <div
          class={`row g-0 popup-main align-items-center ${isModalView ? "ct_auth_modal_card position-relative" : ""}`}
        >
          {isModalView ? (
            <button
              type="button"
              class="ct_auth_modal_close"
              onClick={handleClose}
              aria-label="Close authentication dialog"
            >
              <i class="fa-solid fa-xmark"></i>
            </button>
          ) : null}
          {/* <div class="col-lg-5 d-none d-lg-block login-popup__right position-relative">
            <img src="/assets/img/modal-bg.webp" alt="Authentication banner" />

            <div class="login-img-text">
              <div>
                <p class="ct_fs_35 ct_fw_600 ct_switzer_light">
                  Built for Asset Security and Digital Trust
                </p>
              </div>

              <div>
                <p class="ct_fs_20 ct_fw_400 fst_italic ct_switzer_light">
                  A trusted platform for registering, managing, and protecting
                  assets globally.
                </p>
              </div>
            </div>
          </div> */}
          {/* <!-- LEFT --> */}
          {children}
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
